import styled from 'styled-components';
import { Form as FormContainer } from '@unform/web';

import { SeparateLabel } from '../../../../components/SeparateLabel';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const BackLink = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;

  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 20px;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.primary};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;

  margin-bottom: 32px;
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ContainerAvatar = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const StudentName = styled.h2`
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${colors.onSurface};

  span {
    color: ${colors.primary};
  }
`;

export const Subtitle = styled.p`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};
  margin-top: 4px;

  strong {
    color: ${colors.onSurface};
    font-weight: 700;
  }
`;

export const Save = styled.button`
  padding: 0 32px;
  height: 48px;

  background: linear-gradient(
    135deg,
    ${colors.primary} 0%,
    ${colors.primaryContainer} 100%
  );
  border: none;
  border-radius: ${radius.full};
  cursor: pointer;

  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onPrimary};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Form = styled(FormContainer)`
  display: flex;
  flex-direction: column;
`;

export const Card = styled.div`
  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.lg};
  padding: 28px;
  margin-bottom: 24px;
`;

export const Separate = styled(SeparateLabel)`
  margin-bottom: 24px;
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 32px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Row4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  align-items: end;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ImcField = styled.div`
  flex: 1;

  span {
    display: block;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.onSurfaceVariant};
    margin-left: 4px;
    margin-bottom: 8px;
  }
`;

export const ImcBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  height: 48px;
  padding: 0 16px;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};
  background-color: ${colors.surfaceContainerHigh};

  strong {
    font-size: 20px;
    font-weight: 800;
    color: ${colors.onSurface};
  }

  @media (max-width: 1199px) {
    height: 44px;
  }
`;

export const ImcTag = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 4px 10px;
  border-radius: ${radius.full};
  background-color: ${colors.surfaceContainerHighest};
  color: ${colors.onSurfaceVariant};
  white-space: nowrap;
`;
